<template>
  <div id="footer">
    <div class="footer-top">
      <div class="footer-container">
        <div class="company-name">洋宇集团有限公司</div>
        <div class="footer-info">
          <div class="one" v-if="footerData.address != ''">地址:{{ footerData.address }}</div>
          <div class="one" v-if="footerData.tel != ''">电话:{{ footerData.tel }}</div>
          <div class="one" v-if="footerData.time != ''">手机:{{ footerData.time }}</div>
          <div class="one" v-if="footerData.fax != ''">传真:{{ footerData.fax }}</div>
          <div class="one" v-if="footerData.email != ''">邮箱:{{ footerData.email }}</div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="copyright">
        {{copyright}}
        <br>
        {{beian}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mfooter",
  data() {
    return {
      beian: "",
      copyright: "",
      footerData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(this.$host + "/api/config/get")
        .then((res) => {
          this.beian = res.data.data.beian;
          this.copyright = res.data.data.copyright;
        })
        .catch((err) => {
          console.log(err);
        });
      this.axios
        .get(this.$host + "/api/index/contact")
        .then((res) => {
          this.footerData = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100vw;
  height: 2rem;
}

#footer .footer-container {
  padding: 0.28rem 0.36rem 0.32rem 0.36rem;
}

#footer .footer-top {
  background: #f3f3f3;
}

#footer .footer-top .company-name {
  height: 0.14rem;
  margin-bottom: 0.28rem;
  font-size: 0.20rem;
  font-weight: 500;
  color: #333333;
}

#footer .footer-top .footer-info .one {
  margin-top: 0.11rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}

#footer .footer-bottom {
  background: #323232;
}

#footer .footer-bottom .copyright {
  padding: 8px 0;
  width: 100vw;
  text-align: center;
  font-size: 0.14rem;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.18rem;
}
</style>



// WEBPACK FOOTER //
// src/components/m/Footer.vue